import React from "react";
import { Button, Modal } from "antd";
import { CloseOutlined } from "@ant-design/icons";

interface BasicDisplayModalProps {
  showModal: boolean;
  onClose: () => void;
  content?: React.ReactNode;
  title?: React.ReactNode;
  loadingCancel?: boolean;
  disabledCancel?: boolean;
}

const BasicDisplayModal: React.FC<BasicDisplayModalProps> = ({
  showModal,
  onClose,
  content,
  title,
  loadingCancel,
  disabledCancel,
}) => {
  return (
    <Modal
      title={title}
      open={showModal}
      onCancel={onClose}
      footer={[
        <Button key="close" icon={<CloseOutlined />} onClick={onClose} disabled={disabledCancel} loading={loadingCancel}>
          Close
        </Button>,
      ]}
    >
      {content}
    </Modal>
  );
};
export default BasicDisplayModal;
